module.exports = __webpack_public_path__ + "static/media/ionic-ios-arrow-forward.d070971b.svg";